import React from 'react';
import {useSubHeaderConfig} from 'hooks';
import {DEVICE, useScreenResize} from '@chekin/guestapp-ui-kit';
import PageSideBar from 'components/PageSideBar';
import {CustomIcon} from '@guestapp/old-ui-kit';
import {MenuContainer, MenuItems, MenuIconButton, CloseIconButton} from './styled';

type MenuProps = {
  setActiveMenu?: (state: boolean) => void;
  hideMenu?: boolean;
  showLogo?: boolean;
};

const Menu = ({showLogo}: MenuProps) => {
  const [showMenu, setShowMenu] = React.useState(false);
  const {isMatch: isMobileMode} = useScreenResize(DEVICE.laptop);
  const {
    config: {hideMenu},
  } = useSubHeaderConfig();

  const toggleMenu = React.useCallback(() => {
    const show = !showMenu;
    setShowMenu(show);
  }, [showMenu, setShowMenu]);

  return (
    <>
      {isMobileMode && !hideMenu && (
        <MenuContainer>
          <MenuIconButton className="burger-menu__button" onClick={toggleMenu}>
            <CustomIcon name="blackMenu" size={35} />
          </MenuIconButton>

          <MenuItems $show={showMenu} className="burger-menu__box">
            <CloseIconButton
              onClick={toggleMenu}
              className="burger-menu__close-btn"
              $showLogo={showLogo}
            >
              <CustomIcon name="closeBlack" size="24px" />
            </CloseIconButton>

            <PageSideBar closeMobileMenu={toggleMenu} />
          </MenuItems>
        </MenuContainer>
      )}
    </>
  );
};

export {Menu};
export type {MenuProps};
